/**
 * Breadcrumbs Store Module
 */

// Dependencies
import Vue from 'vue'

// Types
import * as types from '@/lib/store/types'

const state = {
	crumbs: {},
}

const actions = {
	[types.ADD_CRUMB]({ commit }, crumb) {
		commit(types.SET_CRUMB, crumb)
	},
	[types.REMOVE_CRUMB]({ commit }, crumb) {
		commit(types.UNSET_CRUMB, crumb)
	},
}

const mutations = {
	[types.SET_CRUMB](state, crumb) {
		let key = Object.keys(crumb)[0]
		Vue.set(state.crumbs, key, crumb[key])
	},

	[types.UNSET_CRUMB](state, key) {
		Vue.set(state.crumbs, key, null)
	},
}

const getters = {
	crumbs: state => state.crumbs,
}

export default {
	state,
	actions,
	mutations,
	getters,
}



// WEBPACK FOOTER //
// ./src/lib/store/modules/Crumb.js